import { useTranslation } from 'react-i18next';
import { Paper, InputBase, Select, MenuItem, Box, Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';

import 'dayjs/locale/de';

export default function AuditLogsFilters({
  onSearchChange,
  onStartDateChange,
  onEndDateChange,
  onModelChange,
  onResetFilters,
  choosenModel,
  optionModel,
  optionForModel,
  hasActiveFilters,
  searchValue,
  startDate,
  endDate,
}) {
  const { t } = useTranslation();

  return (
    <div
      className="options"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        width: '100%',
        gap: '16px',
        marginBottom: '25px',
      }}
    >
      <Paper
        component="form"
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 300,
          border: '1px solid var(--table-border)',
          borderRadius: '12px',
          backgroundColor: 'var(--table-row-white)',
          boxShadow: 'none',
          '&:hover': {
            border: '1px solid var(--table-border)',
          },
          '&:focus-within': {
            border: '1px solid #3b82f6',
            boxShadow: '0 0 0 3px rgb(59 130 246 / 0.1)',
          },
          '@media (max-width: 574px)': {
            width: '100%',
          },
        }}
      >
        <IconButton
          type="button"
          sx={{
            p: '12px',
            color: 'var(--text-secondary)',
          }}
          aria-label="search"
        >
          <SearchIcon />
        </IconButton>
        <InputBase
          sx={{
            ml: 1,
            flex: 1,
            fontSize: '0.875rem',
            '& input': {
              padding: '12px 16px 12px 0',
              color: 'var(--text-primary)',
            },
          }}
          placeholder={t('generic.search')}
          value={searchValue}
          onChange={onSearchChange}
        />
      </Paper>

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          border: '1px solid var(--table-border)',
          borderRadius: '12px',
          backgroundColor: 'var(--table-row-white)',
          boxShadow: 'none',
          height: '50px',
          minHeight: '50px',
          overflow: 'visible',
          '&:hover': {
            borderColor: 'var(--table-border)',
          },
          '&:focus-within': {
            borderColor: '#3b82f6',
            boxShadow: '0 0 0 3px rgb(59 130 246 / 0.1)',
          },
          '@media (max-width: 574px)': {
            width: '100%',
          },
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <DatePicker
            label={t('generic.from')}
            value={startDate ? dayjs(startDate) : null}
            onChange={onStartDateChange}
            maxDate={dayjs()}
            sx={{
              width: '50%',
              '@media (min-width: 575px)': {
                width: '140px',
              },
              '& .MuiInputBase-root': {
                width: '100%',
                height: '50px',
                border: 'none',
                borderRadius: '0',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover': {
                  border: 'none',
                },
                '&.Mui-focused': {
                  border: 'none',
                  boxShadow: 'none',
                },
                '& fieldset': {
                  border: 'none',
                },
              },
              '& .MuiInputBase-input': {
                padding: '14px 8px',
                fontSize: '0.875rem',
                color: 'var(--text-primary)',
              },
              '& .MuiInputLabel-root': {
                fontSize: '0.75rem',
                left: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translateY(-26px) scale(0.75)',
                  transformOrigin: 'left top',
                },
              },
            }}
          />
        </LocalizationProvider>
        <div
          style={{
            width: '1px',
            height: '24px',
            backgroundColor: 'var(--table-border)',
            margin: '0 8px',
          }}
        />
        <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="de">
          <DatePicker
            label={t('generic.to')}
            value={endDate ? dayjs(endDate) : null}
            onChange={onEndDateChange}
            maxDate={dayjs()}
            sx={{
              width: '50%',
              '@media (min-width: 575px)': {
                width: '140px',
              },
              '& .MuiInputBase-root': {
                width: '100%',
                height: '50px',
                border: 'none',
                borderRadius: '0',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover': {
                  border: 'none',
                },
                '&.Mui-focused': {
                  border: 'none',
                  boxShadow: 'none',
                },
                '& fieldset': {
                  border: 'none',
                },
              },
              '& .MuiInputBase-input': {
                padding: '14px 8px',
                fontSize: '0.875rem',
                color: 'var(--text-primary)',
              },
              '& .MuiInputLabel-root': {
                fontSize: '0.75rem',
                left: '8px',
                top: '50%',
                transform: 'translateY(-50%)',
                '&.Mui-focused, &.MuiFormLabel-filled': {
                  transform: 'translateY(-26px) scale(0.75)',
                  transformOrigin: 'left top',
                },
              },
            }}
          />
        </LocalizationProvider>
      </Box>

      <Select
        labelId="model-select-label"
        id="model-select"
        value={choosenModel}
        onChange={onModelChange}
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: 300,
          border: '1px solid var(--table-border)',
          borderRadius: '12px',
          backgroundColor: 'var(--table-row-white)',
          boxShadow: 'none',
          '&:hover': {
            borderColor: 'var(--table-border)',
          },
          '&.Mui-focused': {
            borderColor: '#3b82f6',
            boxShadow: '0 0 0 3px rgb(59 130 246 / 0.1)',
          },
          '@media (max-width: 574px)': {
            width: '100%',
          },
          '& fieldset': {
            border: 'none',
          },
          '& .MuiSelect-select': {
            padding: '12px 16px',
            fontSize: '0.875rem',
            color: 'var(--text-primary)',
            display: 'flex',
            alignItems: 'center',
            minHeight: 'unset',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
          },
          '& .MuiSelect-icon': {
            color: 'var(--text-secondary)',
            right: '12px',
          },
        }}
        displayEmpty
        renderValue={(selected) => {
          if (selected === '') {
            return <span style={{ color: 'var(--text-secondary)' }}>{t('generic.filter')}</span>;
          }
          return optionForModel[selected] || selected;
        }}
      >
        <MenuItem value="">
          <em>{t('generic.all')}</em>
        </MenuItem>
        {optionModel.map((model, index) => (
          <MenuItem key={index} value={model}>
            {optionForModel[model]}
          </MenuItem>
        ))}
      </Select>

      {hasActiveFilters && (
        <Button
          variant="text"
          onClick={onResetFilters}
          sx={{
            color: 'var(--primary-color)',
            fontSize: '0.875rem',
            textDecoration: 'underline',
            textTransform: 'none',
            padding: '8px 0',
            minWidth: 'auto',
            '&:hover': {
              backgroundColor: 'transparent',
              textDecoration: 'underline',
            },
          }}
        >
          {t('generic.resetFilters')}
        </Button>
      )}
    </div>
  );
}
